module.exports = __webpack_public_path__ + "static/DRON_01-228c8e492e084f084aec2d1661ddd116.jpg";